import { VoiceModel } from "@/actions/db/get-models";
import { useRouter } from "next/navigation";

export const useVoiceCardHandler = () => {
  const router = useRouter();

  const handleDefaultVoiceModelClick = (model: VoiceModel) => {
    (model as VoiceModel).ownerId
      ? router.push(`/convert/${(model as VoiceModel).ownerId}/${model.name}`)
      : router.push(`/convert/${model.name}`);
  };

  return { handleDefaultVoiceModelClick };
};
